import { useTranslation } from "react-i18next";

export const useOptions = () => {
  const { t } = useTranslation();

  const memberShipTypeOptions = [
    { value: "vip", label: t("vip") },
    { value: "family", label: t("family") },
    { value: "youth", label: t("youth") },
  ];
  const daysOptions = [
    { value: "sat", label: t("sat") },
    { value: "sun", label: t("sun") },
    { value: "mon", label: t("mon") },
    { value: "tue", label: t("tue") },
    { value: "wed", label: t("wed") },
    { value: "thu", label: t("thu") },
  ];
  const memberStatusOptions = [
    { value: "active", label: t("active") },
    { value: "inReview", label: t("inReview") },
    { value: "expired", label: t("expired") },
  ];
  const employeesStatusOptions = [
    { value: "active", label: t("active") },
    { value: "vacation", label: t("vacation") },
    { value: "suspended", label: t("suspended") },
  ];
  const addEmployeesStatusOptions = [
    { value: "active", label: t("active") },
    { value: "suspended", label: t("suspended") },
  ];
  const languageOptions = [
    { value: "en", label: "english" },
    { value: "ar", label: "العربية" },
  ];
  const dateFormatOptions = [
    { value: "DD/MM/YYYY", label: "dd/mm/yyyy" },
    { value: "YYYY/MM/DD", label: "yyyy/mm/dd" },
    { value: "YYYY/DD/MM", label: "yyyy/dd/mm" },
  ];
  const addSalaryOptions = [
    { value: "bonus", label: t("bonus") },
    { value: "deduction", label: t("deduction") },
    { value: "advance", label: t("advance") },
  ];

  const paginationOptions = [
    { value: "10", label: t("show 10") },
    { value: "20", label: t("show 20") },
    { value: "30", label: t("show 30") },
    { value: "50", label: t("show 50") },
    { value: "100", label: t("show 100") },
  ];

  return {
    memberShipTypeOptions,
    memberStatusOptions,
    paginationOptions,
    employeesStatusOptions,
    addEmployeesStatusOptions,
    daysOptions,
    addSalaryOptions,
    languageOptions,
    dateFormatOptions,
  };
};
